import { Dispatch } from '@reduxjs/toolkit';
import { setTransportHubs } from '../actions';
import { AppState } from '../store';

export function getTransportHubs(): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    try {
      const data = await fetch(`${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/TransportHub`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const transportHubs = await data.json();
      dispatch(setTransportHubs(transportHubs));
    } catch (error) {
      console.error(error);
    }
  };
}
